import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import WithdrawReqModal from "../../../components/Modals/WithdrawReqModal";
import { SearchIcon } from "lucide-react";
// import useSocket from "../../../components/useSocket";
import DepositReqCard from "../Deposit/DepositReqCard";
import { useSocket } from "../../../context/SocketContext";

const WithdrawRequests = () => {
  const { socket } = useSocket(); // Backend URL

  const axiosPrivate = useAxiosPrivate();
  const [WithdrawData, setWithdrawData] = useState([]);
  const [showWithdrawModal, setshowWithdrawModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [searchInput, setSearchInput] = useState("");

  const handleOnClose = () => {
    setshowWithdrawModal(false);
  };
  const handleWithdrawSearch = async () => {
    await axiosPrivate
      .get(`/easypaisa/depositRequest/`, {
        withCredentials: true,
        params: {
          id: searchInput,
        },
      })
      .then((res) => {
        console.log(res.data);
        setWithdrawData(res?.data?.setWithdrawData);
        // setMatch(res.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    // Fetch initial listings
    const fetchListings = async () => {
      await axiosPrivate
        .get(`/easypaisa/WithdrawRequest/`, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);
          setWithdrawData(res?.data?.WithdrawReqs);
          // setMatch(res.data);
        })
        .catch((err) => console.log(err));
    };

    fetchListings();

    // Clean up the socket connection
    return () => {};
  }, [axiosPrivate]);

  useEffect(() => {
    console.log("socket trying to run deposit card");
    // Listen for new listings via Socket.IO
    socket?.on("WithdrawChange", async (change) => {
      console.log("socketiio withdrawCard", change);
      if (change?.fullDocument) {
        await axiosPrivate
          .get(`/easypaisa/WithdrawRequest/`, {
            withCredentials: true,
          })
          .then((res) => {
            console.log(res.data);
            setWithdrawData(res?.data?.WithdrawReqs);
            // setMatch(res.data);
          })
          .catch((err) => console.log(err));
        // setWithdrawData((prev) => [change?.fullDocument, ...prev]);
      } else {
        await axiosPrivate
          .get(`/easypaisa/WithdrawRequest/`, {
            withCredentials: true,
          })
          .then((res) => {
            console.log(res.data);
            setWithdrawData(res?.data?.WithdrawReqs);
            // setMatch(res.data);
          })
          .catch((err) => console.log(err));
      }
    });

    // Clean up the socket connection
    return () => {};
  }, [WithdrawData, axiosPrivate, socket]);

  return (
    <div>
      {showWithdrawModal && WithdrawData && (
        <WithdrawReqModal
          visible={showWithdrawModal}
          onClose={handleOnClose}
          data={selectedData}
          key={selectedData?._id}
        />
      )}
      <div className="container mx-auto py-10 flex justify-center h-screen">
        <div className="w-full pl-4  h-full flex flex-col">
          <div className="bg-black text-lg text-white font-bold px-5 py-2 shadow border-b border-gray-300">
            <div className="flex justify-between">
              <p>Withdraw Requests - {WithdrawData?.length}</p>
              <img
                src="https://api.iconify.design/hugeicons:system-update-02.svg?color=%23ffffff"
                className="w-[45px] h-[45px] "
                style={{ cursor: "pointer" }}
                alt="refresh filter"
                // onClick={async () => {
                //   await axiosPrivate
                //     .get("/easypaisa/depositRequest", { withCredentials: true })
                //     .then((res) => {
                //       console.log(res.data);
                //       setDepositData(res.data);
                //     });
                // }}
              />
              <div className="flex">
                <input
                  value={searchInput}
                  onChange={(e) => {
                    e.preventDefault();
                    setSearchInput(e.target.value);
                  }}
                  type="Number"
                  placeholder="Search depositId"
                  className="block me-2 appearance-none w-full bg-gray-200 border border-gray-200 text-black py-3 px-4 pr-8 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                />
                <button
                  onClick={handleWithdrawSearch}
                  className="w-[200px] tracking-wide flex justify-between px-3 font-semibold bg-purple-500 text-white-500 w-full  rounded-lg hover:bg-purple-700 hover:text-purple-800 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                >
                  Search <SearchIcon />
                </button>
              </div>
            </div>
            {/* <p>New - {depositData?.length}</p> */}
          </div>

          <div
            className="w-full h-full overflow-auto shadow bg-black bg-opacity-70"
            id="journal-scroll"
          >
            <table className="w-full">
              <tbody className="">
                {WithdrawData?.map((data) => {
                  return (
                    <>
                      <tr
                        className="relative transform scale-100
                      text-xs py-1 border-b-2 border-blue-100 cursor-pointer

              bg-opacity-50"
                        onClick={() => {
                          setSelectedData(data); // Set selected data
                          setshowWithdrawModal(true);
                        }}
                      >
                        <DepositReqCard data={data} key={data?._id} />
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawRequests;
